import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, IconButton, FormControlLabel, Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import { useDataProvider, useTranslate, Loading, usePermissions } from 'react-admin';
import { useHistory, Prompt } from 'react-router-dom';
import TextField from '../CustomizedUIs/CustomTextFiled';
import { red, pink } from '@material-ui/core/colors';
import SelectBoxFilter from '../common/select-box-filter';
import LoadingSave from '../common/loading-page';
import { lightBlue, grey } from '@material-ui/core/colors';
import Snackbar from '../common/snackbar';
import CustomSwitch from '../CustomizedUIs/GreenSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { isBlockingSettings, pathNameSettings } from '../redux/actions/settings-action';
import ChipInput from 'material-ui-chip-input';
import colors from '../CustomizedUIs/Colors';
import { Close } from '@material-ui/icons';
import { LoadingButton } from '../common/button';
import imageInfo from '../assets/infochanges.png';
import { cloneDeep } from 'lodash';

const bgColorError = pink['50'];
const textColorError = red['700'];

const dataCategory = [
    { id: 1, name: 'All' },
    { id: 2, name: 'Client' },
    { id: 3, name: 'General' },
    { id: 4, name: 'Services' },
    { id: 5, name: 'Support' },
];

const dataDLX = [
    { id: 1, name: 'None' },
    { id: 2, name: 'TV' },
    { id: 3, name: 'Menu' },
]
const dataInactiviTyTimeoutAction = [
    { id: 1, name: 'None' },
    { id: 2, name: 'Put device in standby' },
    { id: 3, name: 'Go to main menu' },
]

const dataInitialVolume = [
    { id: 1, name: '-1' },
    { id: 2, name: '0' },
    { id: 3, name: '5' },
    { id: 4, name: '10' },
    { id: 5, name: '15' },
    { id: 6, name: '20' },
    { id: 7, name: '25' },
    { id: 8, name: '30' },
    { id: 9, name: '35' },
    { id: 10, name: '40' },
    { id: 11, name: '45' },
    { id: 12, name: '50' },
    { id: 13, name: '55' },
    { id: 14, name: '60' },
    { id: 15, name: '65' },
    { id: 16, name: '70' },
    { id: 17, name: '75' },
    { id: 18, name: '80' },
    { id: 19, name: '85' },
    { id: 20, name: '90' },
    { id: 21, name: '95' },
    { id: 22, name: '100' },
];

const timeZoneData = [
    { id: 1, name: '-11' },
    { id: 2, name: '-10' },
    { id: 3, name: '-9' },
    { id: 4, name: '-8' },
    { id: 5, name: '-7' },
    { id: 6, name: '-6' },
    { id: 7, name: '-5' },
    { id: 8, name: '-4' },
    { id: 9, name: '-3' },
    { id: 10, name: '-2' },
    { id: 11, name: '-1' },
    { id: 12, name: '+0' },
    { id: 13, name: '+1' },
    { id: 14, name: '+2' },
    { id: 15, name: '+3' },
    { id: 16, name: '+4' },
    { id: 17, name: '+5' },
    { id: 18, name: '+6' },
    { id: 19, name: '+7' },
    { id: 20, name: '+8' },
    { id: 21, name: '+9' },
    { id: 22, name: '+10' },
    { id: 23, name: '+11' },
    { id: 24, name: '+12' },
];



const useStyles = makeStyles(theme => ({
    chipInput: {
        marginLeft: 8,
        backgroundColor: theme.palette.grey['200'],
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        maxWidth: 480
    },
    input: {
        // backgroundColor: 'white',
        // "&:hover": {
        //     backgroundColor: 'white'
        // },
        borderRadius: '2px',
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingLeft: '16px !important',
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none"
        },
        "& input": {
            "-moz-appearance": "textfield"
        }
    },
    boxBorder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    password: {
        "& input": {
            fontFamily: 'text-security-disc',
            "-webkit-text-security": "disc",
        }
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '1px solid' + '#eb5a4d'
        },
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    titleCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: " #4f5064",
    },
    textErrorChipInput: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        paddingLeft: '16px',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        paddingLeft: '16px'
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
        paddingLeft: '28px'
    },
    textLabelError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',

    },
    textValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    btnCancel: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        color: '#237fc2',
    },
    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '12px',
        top: '10px'
    },
    iconButton: {
        margin: 'auto',
        borderRadius: '10px',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '8px'
    },
    removeIcon: {
        borderRadius: '10px',
        color: '#237fc2',
        backgroundColor: '#c1e5fa',
        padding: 4
    },
    buttonBoxSave: {
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingRight: 20,
        marginLeft: 'auto',
    },
    buttonBoxSaveBottom: {
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingRight: 20,
        marginLeft: 'auto',
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    enabled: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
    textForce: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        padding: '5px 8px 5px 8px'
    },
    paper: {
        display: 'block'
    },
    container: {
        width: 450,
        textAlign: 'center',
        backgroundColor: '#f3f7fa',
        paddingBottom: theme.spacing(5)
    },
    btnCancel: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        color: '#237fc2',
    },
    titleUnSave: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    contentUnSave: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
        paddingTop: '10px'
    },
    textClose: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
    },
    borderClose: {
        width: '25px',
        height: '25px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        marginLeft: '10px'
    },
}));


const Settings = ({ isEdit, cluster, room, isSave, setIsSave, isChange, setIsChange, isSaveInRoom, setEditData, clusterData,
    setIsSaveInRoom, isChangeInRoom, setIsChangeInRoom, setValue, setValueDialogEditRoom, newValue, newValueDialogEditRoom, ...props }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const { permissions, loaded } = usePermissions();
    const history = useHistory();
    const [device, setDevice] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const [openDialogAlert, setOpenDialogAlert] = useState(false);
    const [messageError, setMessageError] = useState('')
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [showSnackbarSave, setShowSnackbarSave] = useState(false);
    const [categoryChannel, setCategotyChannel] = useState(false);
    let is_blocking_settings = useSelector((state) => state.is_blocking_settings);
    const path_name_settings = useSelector((state) => state.path_name_settings);
    const dispatch = useDispatch();
    const [data, setData] = useState([])
    const [languages, setLanguages] = useState([]);

    // selectbox
    const [dataCategoryFilter, setDataCategoryFilter] = useState([]);
    const [category, setCategory] = useState();
    const [timeZone, setTimeZone] = useState();
    // const [audioLanguage1, setAudioLanguage1] = useState('');
    // const [audioLanguage2, setAudioLanguage2] = useState('');

    const [DLXStartupMode, setDLXStartupMode] = useState('');
    const [infoPage, setInfoPage] = useState('');
    const [infoPageList, setInfoPageList] = useState([]);
    const [initialVolume, setInitialVolume] = useState('');
    const [defaultChannelGroup, setDefaultChannelGroup] = useState('');
    const [defaultSystemLanguage, setDefaultSystemLanguage] = useState('');
    const [inactivityTimeoutAction, setInactivityTimeoutAction] = useState('');
    // checkbox
    const [playbackError, setPlaybackError] = useState(false);
    const [DLXUseStartupMode, setDLXUseStartupMode] = useState(false);
    const [buttonMainMenu, setButtonMainMenu] = useState(false);
    const [subtitlesEnabled, setSubtitlesEnabled] = useState(false);
    const [useSession, setUseSession] = useState(false);
    // testbox
    const [emailSupports, setEmailSupports] = useState([]);
    const [textValue, setTextValue] = useState({
        channelNumberInputTimeout: '',
        multicast: '',
        inactivityTimeout: '',
        // subtitleLanguage1: '',
        // subtitleLanguage2: '',
        infoChannelMaxUploadSize: '',
        browserHomepage: '',
        supportMessageEmail: '',
        errorAlertLimit: '',
        defaultLockCode: '',
        defaultPinCode: '',
        maxDelayOnUpgrade: '',
        minDelayOnUpgrade: '',
        onUpgrade: '',
        maxTriggeredRequests: '',
        emailEncoding: '',
        emailPassword: '',
        emailPort: '',
        emailReply: '',
        emailServer: '',
        emailSmtpTimeout: '',
        emailUsername: '',
        emailUsetls: '',
    })
    const [error, setError] = useState({
        name: { status: device.id ? false : true, message: '' },
        ipAddress: { status: device.id ? false : true, message: '' },
        macAddress: { status: device.id ? false : true, message: '' },
        macAddressSecondary: { status: device.id ? false : true, message: '' },
        serialNumber: { status: device.id ? false : true, message: '' },
        tvModel: { status: device.id ? false : true, message: '' },
    });

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const onChangTextValue = (prop) => (e) => {
        if (!cluster)
            dispatch(isBlockingSettings(true))
        else {
            if (room) {
                setIsChangeInRoom(true)
            }
            else
                setIsChange(true)
        }
        if (prop === 'defaultPinCode' || prop === 'defaultLockCode') {
            if (e.target.value.length <= 6) {
                setTextValue({
                    ...textValue, [prop]: e.target.value
                })
            }
        } else {
            setTextValue({
                ...textValue, [prop]: e.target.value
            })
        }
        // validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        if (prop === 'name') {
            if (value.length === 0) {
                setError({
                    ...error, [prop]: value.length === 0 ? {
                        status: true, message: translate('pos.messages.required')
                    } : { status: false, message: '' }
                })
            }
            else {
                setError({
                    ...error, [prop]:
                        { status: false, message: '' }
                })
            }
        }
    }

    const getSettings = (infoPages, channelGroup, listLanguage) => {
        dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: cluster ? cluster : null,
                room: room ? room : null
            },
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            let channelNumberInputTimeout = '';
            let multicast = '';
            let inactivityTimeout = '';
            let defaultLockCode = '';
            let defaultPinCode = '';
            let maxDelayOnUpgrade = '';
            let minDelayOnUpgrade = '';
            let onUpgrade = '';
            let maxTriggeredRequests = '';
            let infoChannelMaxUploadSize = '';
            let browserHomepage = '';
            let supportMessageEmail = '';
            let emailEncoding = '';
            let emailPassword = '';
            let emailPort = '';
            let emailReply = '';
            let emailServer = '';
            let emailUsername = '';
            let emailSmtpTimeout = '';
            let emailUsetls = '';
            let errorAlertLimit = '';
            for (let i = 0; i < data.length; i++) {
                switch (data[i].name) {
                    case 'Channel Number Input Timeout':
                        channelNumberInputTimeout = data[i].value
                        break;
                    case 'Multicast IP Ranges':
                        multicast = data[i].value
                        break;
                    case 'Retry On Channel Playback Error':
                        setPlaybackError(data[i].value === 'true' ? true : false)
                        break;
                    case 'Use Channel Categories':
                        setCategotyChannel(data[i].value === 'true' ? true : false)
                        break;
                    case 'DLX Startup Mode':
                        dataDLX.map(item => {
                            if (item.name === data[i].value)
                                setDLXStartupMode(item)
                        })
                        break;
                    case 'DLX Use Startup Mode On Resume':
                        setDLXUseStartupMode(data[i].value === 'true' ? true : false)
                        break;
                    case 'Inactivity Timeout':
                        inactivityTimeout = data[i].value
                        break;
                    case 'Inactivity Timeout Action':
                        dataInactiviTyTimeoutAction.map(item => {
                            if (item.name === data[i].value)
                                setInactivityTimeoutAction(item)
                        })
                        break;
                    case 'Info Page':
                        if (props.infoPageId) {
                            infoPages.map(item => {
                                if (item.id === props.infoPageId)
                                    setInfoPage(item)
                            })
                        }
                        else {
                            if (data[i].value !== '') {
                                const infoPageData = JSON.parse(data[i].value)
                                infoPages.map(item => {
                                    if (item.id === infoPageData.id)
                                        setInfoPage(item)
                                })
                            }
                        }
                        break;
                    case 'Initial Volume':
                        dataInitialVolume.map(item => {
                            if (item.name == data[i].value)
                                setInitialVolume(item)
                        })
                        break;
                    case 'Menu Button Always Goes To Main Menu':
                        setButtonMainMenu(data[i].value === 'true' ? true : false)
                        break;
                    case 'Default channel Group':
                        if (data[i].value !== '') {
                            const defaultChannelGroupData = JSON.parse(data[i].value).id
                            channelGroup.map(item => {
                                if (item.id === defaultChannelGroupData)
                                    setDefaultChannelGroup(item)
                            })
                        }
                        break;
                    case 'Subtitles Enabled':
                        setSubtitlesEnabled(data[i].value === 'true' ? true : false)
                        break;
                    case 'Use Session Bookmarks':
                        setUseSession(data[i].value === 'true' ? true : false)
                        break;
                    case 'Default Lock Code':
                        defaultLockCode = data[i].value
                        break;
                    case 'Default Pin Code':
                        defaultPinCode = data[i].value
                        break;
                    case 'Client Operation Max Delay On Upgrade':
                        maxDelayOnUpgrade = data[i].value
                        break;
                    case 'Client Operation Min Delay On Upgrade':
                        minDelayOnUpgrade = data[i].value
                        break;
                    case 'Client Operation On Upgrade':
                        onUpgrade = data[i].value
                        break;
                    case 'Max Triggered Requests Per Second':
                        maxTriggeredRequests = data[i].value
                        break;
                    case 'Info Channel Max Upload Size':
                        infoChannelMaxUploadSize = data[i].value
                        break;
                    case 'Default System Language':
                        listLanguage.map(item => {
                            if (item.name === data[i].value)
                                setDefaultSystemLanguage(item)
                        })
                        break;
                    case 'Browser Homepage':
                        browserHomepage = data[i].value
                        break;
                    case 'Time Zone':
                        timeZoneData.map(item => {
                            if (item.name === data[i].value) {
                                setTimeZone(item)
                            }
                        })
                        break;
                    case 'Support message e-mail':
                        if (data[i].value !== '')
                            setEmailSupports(JSON.parse(data[i].value))
                        break;
                    case 'Email Encoding':
                        emailEncoding = data[i].value
                        break;
                    case 'Email Password':
                        emailPassword = data[i].value
                        break;
                    case 'Email Port':
                        emailPort = data[i].value
                        break;
                    case 'Email Reply':
                        emailReply = data[i].value
                        break;
                    case 'Email Server':
                        emailServer = data[i].value
                        break;
                    case 'Email Username':
                        emailUsername = data[i].value
                        break;
                    case 'Email Smtp Timeout':
                        emailSmtpTimeout = data[i].value
                        break;
                    case 'Email Usetls':
                        emailUsetls = data[i].value
                        break;
                    case 'Error Alert Limit':
                        errorAlertLimit = data[i].value
                        break;
                }
            }
            setTextValue({
                channelNumberInputTimeout,
                multicast,
                inactivityTimeout,
                infoChannelMaxUploadSize,
                browserHomepage,
                supportMessageEmail,
                errorAlertLimit,
                defaultLockCode,
                defaultPinCode,
                maxDelayOnUpgrade,
                minDelayOnUpgrade,
                onUpgrade,
                maxTriggeredRequests,
                emailEncoding,
                emailPassword,
                emailPort,
                emailReply,
                emailServer,
                emailSmtpTimeout,
                emailUsername,
                emailUsetls,
            })
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });
    }

    const arraySetting = () => {
        let array = []
        let infoPageValue = infoPage === '' ? '' : JSON.stringify(infoPage)
        let defaultChannelGroupValue = defaultChannelGroup === '' ? '' : JSON.stringify(defaultChannelGroup)
        if (!cluster && !room) {
            array = [
                { name: "Channel Number Input Timeout", group: 'Client :: Channel', value: textValue.channelNumberInputTimeout },
                { name: "Multicast IP Ranges", group: 'Client :: Channel', value: textValue.multicast },
                { name: "Retry On Channel Playback Error", group: 'Client :: Channel', value: playbackError ? 'true' : 'false' },
                { name: "Use Channel Categories", group: 'Client :: Channel', value: categoryChannel ? 'true' : 'false' },
                // { name: "Audio Language 1st", group: 'Client :: Channel', value: audioLanguage1.name },
                // { name: "Audio Language 2nd", group: 'Client :: Channel', value: audioLanguage2.name },
                { name: "DLX Startup Mode", group: 'Client :: Channel', value: DLXStartupMode ? DLXStartupMode.name : '' },
                { name: "DLX Use Startup Mode On Resume", group: 'Client :: Channel', value: DLXUseStartupMode ? 'true' : 'false' },
                { name: "Inactivity Timeout", group: 'Client :: Channel', value: textValue.inactivityTimeout },
                { name: "Inactivity Timeout Action", group: 'Client :: Channel', value: inactivityTimeoutAction ? inactivityTimeoutAction.name : '' },
                { name: "Info Page", group: 'Client :: Channel', value: infoPageValue },
                { name: "Initial Volume", group: 'Client :: Channel', value: initialVolume.name },
                { name: "Menu Button Always Goes To Main Menu", group: 'Client :: Channel', value: buttonMainMenu ? 'true' : 'false' },
                // { name: "Subtitle Language 1st", group: 'Client :: Channel', value: textValue.subtitleLanguage1 },
                // { name: "Subtitle Language 2nd", group: 'Client :: Channel', value: textValue.subtitleLanguage2 },
                { name: "Default channel Group", group: 'Client :: Channel', value: defaultChannelGroupValue },
                { name: "Subtitles Enabled", group: 'Client :: Channel', value: subtitlesEnabled ? 'true' : 'false' },
                { name: "Use Session Bookmarks", group: 'Client :: Channel', value: useSession ? 'true' : 'false' },
                { name: "Default Lock Code", group: 'Client :: Channel', value: textValue.defaultLockCode },
                { name: "Default Pin Code", group: 'Client :: Channel', value: textValue.defaultPinCode },
                { name: "Client Operation Max Delay On Upgrade", group: 'Client :: Channel', value: textValue.maxDelayOnUpgrade },
                { name: "Client Operation Min Delay On Upgrade", group: 'Client :: Channel', value: textValue.minDelayOnUpgrade },
                { name: "Client Operation On Upgrade", group: 'Client :: Channel', value: textValue.onUpgrade },
                { name: "Max Triggered Requests Per Second", group: 'Client :: Channel', value: textValue.maxTriggeredRequests },
                { name: "Info Channel Max Upload Size", group: 'General :: Info Channels', value: textValue.infoChannelMaxUploadSize },
                { name: "Default System Language", group: 'General :: Languages and Locales', value: defaultSystemLanguage ? defaultSystemLanguage.name : '' },
                { name: "Browser Homepage", group: 'Services :: Services', value: textValue.browserHomepage },
                { name: "Time Zone", group: 'Services :: Services', value: timeZone.name },
                { name: "Support message e-mail", group: 'Support :: Email', value: JSON.stringify(emailSupports) },
                { name: "Email Encoding", group: 'Support :: Email', value: textValue.emailEncoding },
                { name: "Email Password", group: 'Support :: Email', value: textValue.emailPassword },
                { name: "Email Port", group: 'Support :: Email', value: textValue.emailPort },
                { name: "Email Reply", group: 'Support :: Email', value: textValue.emailReply },
                { name: "Email Server", group: 'Support :: Email', value: textValue.emailServer },
                { name: "Email Username", group: 'Support :: Email', value: textValue.emailUsername },
                { name: "Email Smtp Timeout", group: 'Support :: Email', value: textValue.emailSmtpTimeout },
                { name: "Email Usetls", group: 'Support :: Email', value: textValue.emailUsetls },
                { name: "Error Alert Limit", group: 'Support :: Support', value: textValue.errorAlertLimit }
            ]
        }
        if (cluster && !room) {
            if (infoPage !== '') {
                let cloneClusterData = cloneDeep(clusterData)
                cloneClusterData.infopage = 0
                setEditData(cloneClusterData)
            }
            else {
                let cloneClusterData = cloneDeep(clusterData)
                cloneClusterData.infopage = JSON.stringify(infoPage).id
                setEditData(cloneClusterData)
            }
            array = [
                { name: "Channel Number Input Timeout", group: 'Client :: Channel', value: textValue.channelNumberInputTimeout },
                { name: "Multicast IP Ranges", group: 'Client :: Channel', value: '' },
                { name: "Retry On Channel Playback Error", group: 'Client :: Channel', value: playbackError ? 'true' : 'false' },
                { name: "Use Channel Categories", group: 'Client :: Channel', value: categoryChannel ? 'true' : 'false' },
                { name: "DLX Startup Mode", group: 'Client :: Channel', value: DLXStartupMode ? DLXStartupMode.name : '' },
                { name: "DLX Use Startup Mode On Resume", group: 'Client :: Channel', value: DLXUseStartupMode ? 'true' : 'false' },
                { name: "Inactivity Timeout", group: 'Client :: Channel', value: textValue.inactivityTimeout },
                { name: "Inactivity Timeout Action", group: 'Client :: Channel', value: inactivityTimeoutAction ? inactivityTimeoutAction.name : '' },
                { name: "Info Page", group: 'Client :: Channel', value: infoPageValue },
                { name: "Initial Volume", group: 'Client :: Channel', value: initialVolume.name },
                { name: "Menu Button Always Goes To Main Menu", group: 'Client :: Channel', value: buttonMainMenu ? 'true' : 'false' },
                { name: "Default channel Group", group: 'Client :: Channel', value: defaultChannelGroupValue },
                { name: "Subtitles Enabled", group: 'Client :: Channel', value: subtitlesEnabled ? 'true' : 'false' },
                { name: "Use Session Bookmarks", group: 'Client :: Channel', value: useSession ? 'true' : 'false' },
                { name: "Default Lock Code", group: 'Client :: Channel', value: '' },
                { name: "Default Pin Code", group: 'Client :: Channel', value: '' },
                { name: "Client Operation Max Delay On Upgrade", group: 'Client :: Channel', value: textValue.maxDelayOnUpgrade },
                { name: "Client Operation Min Delay On Upgrade", group: 'Client :: Channel', value: textValue.minDelayOnUpgrade },
                { name: "Client Operation On Upgrade", group: 'Client :: Channel', value: textValue.onUpgrade },
                { name: "Max Triggered Requests Per Second", group: 'Client :: Channel', value: textValue.maxTriggeredRequests },
                { name: "Info Channel Max Upload Size", group: 'General :: Info Channels', value: '' },
                { name: "Default System Language", group: 'General :: Languages and Locales', value: '' },
                { name: "Browser Homepage", group: 'Services :: Services', value: textValue.browserHomepage },
                { name: "Time Zone", group: 'Services :: Services', value: timeZone.name },
                { name: "Support message e-mail", group: 'Support :: Email', value: JSON.stringify(emailSupports) },
                { name: "Email Encoding", group: 'Support :: Email', value: '' },
                { name: "Email Password", group: 'Support :: Email', value: '' },
                { name: "Email Port", group: 'Support :: Email', value: '' },
                { name: "Email Reply", group: 'Support :: Email', value: '' },
                { name: "Email Server", group: 'Support :: Email', value: '' },
                { name: "Email Username", group: 'Support :: Email', value: '' },
                { name: "Email Smtp Timeout", group: 'Support :: Email', value: '' },
                { name: "Email Usetls", group: 'Support :: Email', value: '' },
                { name: "Error Alert Limit", group: 'Support :: Support', value: '' }
            ]
        }
        if (cluster && room) {
            array = [
                { name: "Channel Number Input Timeout", group: 'Client :: Channel', value: textValue.channelNumberInputTimeout },
                { name: "Multicast IP Ranges", group: 'Client :: Channel', value: '' },
                { name: "Retry On Channel Playback Error", group: 'Client :: Channel', value: '' },
                { name: "Use Channel Categories", group: 'Client :: Channel', value: '' },
                { name: "DLX Startup Mode", group: 'Client :: Channel', value: DLXStartupMode ? DLXStartupMode.name : '' },
                { name: "DLX Use Startup Mode On Resume", group: 'Client :: Channel', value: DLXUseStartupMode ? 'true' : 'false' },
                { name: "Inactivity Timeout", group: 'Client :: Channel', value: textValue.inactivityTimeout },
                { name: "Inactivity Timeout Action", group: 'Client :: Channel', value: inactivityTimeoutAction ? inactivityTimeoutAction.name : '' },
                { name: "Info Page", group: 'Client :: Channel', value: infoPageValue },
                { name: "Initial Volume", group: 'Client :: Channel', value: initialVolume.name },
                { name: "Menu Button Always Goes To Main Menu", group: 'Client :: Channel', value: buttonMainMenu ? 'true' : 'false' },
                { name: "Default channel Group", group: 'Client :: Channel', value: defaultChannelGroupValue },
                { name: "Subtitles Enabled", group: 'Client :: Channel', value: subtitlesEnabled ? 'true' : 'false' },
                { name: "Use Session Bookmarks", group: 'Client :: Channel', value: useSession ? 'true' : 'false' },
                { name: "Default Lock Code", group: 'Client :: Channel', value: '' },
                { name: "Default Pin Code", group: 'Client :: Channel', value: '' },
                { name: "Client Operation Max Delay On Upgrade", group: 'Client :: Channel', value: textValue.maxDelayOnUpgrade },
                { name: "Client Operation Min Delay On Upgrade", group: 'Client :: Channel', value: textValue.minDelayOnUpgrade },
                { name: "Client Operation On Upgrade", group: 'Client :: Channel', value: textValue.onUpgrade },
                { name: "Max Triggered Requests Per Second", group: 'Client :: Channel', value: textValue.maxTriggeredRequests },
                { name: "Info Channel Max Upload Size", group: 'General :: Info Channels', value: '' },
                { name: "Default System Language", group: 'General :: Languages and Locales', value: '' },
                { name: "Browser Homepage", group: 'Services :: Services', value: '' },
                { name: "Time Zone", group: 'Services :: Services', value: timeZone.name },
                { name: "Support message e-mail", group: 'Support :: Email', value: '' },
                { name: "Email Encoding", group: 'Support :: Email', value: '' },
                { name: "Email Password", group: 'Support :: Email', value: '' },
                { name: "Email Port", group: 'Support :: Email', value: '' },
                { name: "Email Reply", group: 'Support :: Email', value: '' },
                { name: "Email Server", group: 'Support :: Email', value: '' },
                { name: "Email Username", group: 'Support :: Email', value: '' },
                { name: "Email Smtp Timeout", group: 'Support :: Email', value: '' },
                { name: "Email Usetls", group: 'Support :: Email', value: '' },
                { name: "Error Alert Limit", group: 'Support :: Support', value: '' }
            ]
        }
        return array
    }


    const onEdit = () => {
        setSaving(true)
        dataProvider('CREATE', 'settings', {
            data: {
                cluster: cluster ? cluster : null,
                room: room ? room : null,
                settings: arraySetting(),
            }
        }).then(() => {
            if (isChange)
                setIsChange(false)
            if (isChangeInRoom)
                setIsChangeInRoom(false)
            if (isSave) {
                setValue(newValue)
                setIsSave(false)
            }
            if (isSaveInRoom) {
                setValueDialogEditRoom(newValueDialogEditRoom)
                setIsSaveInRoom(false)
            }
            let getElementScrollTopCluster = document.getElementById('containerClusterEditDialog')
            if (getElementScrollTopCluster)
                scrollTop(getElementScrollTopCluster, 0, 0);
            else {
                let getElementScrollTopRoom = document.getElementById('containerRoomEditDialog')
                if (getElementScrollTopRoom)
                    scrollTop(getElementScrollTopRoom, 0, 0);
                else
                    window.scrollTo(0, 0)
            }
            setShowSnackbarSave(true);
            setSaving(false);
            if (!cluster) {
                dispatch(isBlockingSettings(false))
                history.replace(path_name_settings)
                dispatch(pathNameSettings('/settings'))
            }
        }).catch(({ message }) => {
            setSaving(false);
            let getElementScrollTopCluster = document.getElementById('containerClusterEditDialog')
            if (getElementScrollTopCluster)
                scrollTop(getElementScrollTopCluster, 0, 0);
            else {
                let getElementScrollTopRoom = document.getElementById('containerRoomEditDialog')
                if (getElementScrollTopRoom)
                    scrollTop(getElementScrollTopRoom, 0, 0);
            }
            setMessageError(translate(message));
        });
    }

    const scrollTop = (element, change, duration) => {
        if (!cluster)
            window.scrollTo(0, 0);
        else {
            var start = element.scrollTop,
                currentTime = 0,
                increment = 10;


            var animateScroll = function () {
                currentTime += increment;
                var val = Math.easeInOutQuad(currentTime, start, change, duration);
                element.scrollTop = val;
                if (currentTime < duration) {
                    setTimeout(animateScroll, increment);
                }
            };
            animateScroll();
        }
    }

    const onChangeCategory = (value, name) => {
        if (!cluster)
            dispatch(isBlockingSettings(true))
        else {
            if (room) {
                setIsChangeInRoom(true)
            }
            else
                setIsChange(true)
        }
        switch (name) {
            case 'category':
                setCategory(value)
                break;
            case 'timeZone':
                setTimeZone(value)
                break;
            // case 'audioLanguage2':
            //     setAudioLanguage2(value)
            //     break;
            case 'DLXStartupMode':
                if (value.name === 'None')
                    setDLXStartupMode(null)
                else
                    setDLXStartupMode(value)
                break;
            case 'infoPage':
                if (value.id === 'None')
                    setInfoPage('')
                else
                    setInfoPage(value)
                break;
            case 'initialVolume':
                setInitialVolume(value)
                break;
            case 'defaultChannelGroup':
                setDefaultChannelGroup(value)
                break;
            case 'defaultSystemLanguage':
                setDefaultSystemLanguage(value)
                break;
            case 'inactivityTimeoutAction':
                if (value.name === 'None')
                    setInactivityTimeoutAction(null)
                else
                    setInactivityTimeoutAction(value)
                break;
        }
    }

    const handleChangeSwitch = (e, name) => {
        if (!cluster)
            dispatch(isBlockingSettings(true))
        else {
            if (room) {
                setIsChangeInRoom(true)
            }
            else
                setIsChange(true)
        }
        switch (name) {
            case 'categoryChannel':
                setCategotyChannel(e.target.checked);
                break;
            case 'playbackError':
                setPlaybackError(e.target.checked);
                break;
            case 'DLXUseStartupMode':
                setDLXUseStartupMode(e.target.checked);
                break;
            case 'buttonMainMenu':
                setButtonMainMenu(e.target.checked);
                break;
            case 'subtitlesEnabled':
                setSubtitlesEnabled(e.target.checked);
                break;
            case 'useSession':
                setUseSession(e.target.checked);
                break;
        };
    }

    const handleAddChip = (chip) => {
        if (!cluster)
            dispatch(isBlockingSettings(true))
        else {
            if (room) {
                setIsChangeInRoom(true)
            }
            else
                setIsChange(true)
        }
        if (((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(chip)) === true) {
            if (emailSupports.length < 5) {
                let temp = emailSupports.slice()
                temp.push(chip)
                setEmailSupports(temp)
            }
        }
    }

    const handleDeleteChip = (chip, index) => {
        if (!cluster)
            dispatch(isBlockingSettings(true))
        else {
            if (room) {
                setIsChangeInRoom(true)
            }
            else
                setIsChange(true)
        }
        if (emailSupports.length > 1) {
            let temp = emailSupports.slice()
            temp.splice(index, 1)
            setEmailSupports(temp)
        }
    }

    const handleCloseDialogAlert = () => {
        setOpenDialogAlert(false)
    }

    const handleCancelDialog = () => {
        is_blocking_settings = false;
        dispatch(isBlockingSettings(is_blocking_settings))
        history.replace(path_name_settings)
        dispatch(pathNameSettings('/settings'))
    }

    const onSave = () => {
        if (!cluster) {
            is_blocking_settings = false
            dispatch(isBlockingSettings(is_blocking_settings))
            setOpenDialogAlert(false)
            onEdit()
        }
    }

    const disableChange = () => {
        if (cluster && !room && !permissions.functionAction.find(value => value.function === 'Cluster settings' && value.isUpdate)) return true
        if (cluster && room && !permissions.functionAction.find(value => value.function === 'Room settings' && value.isUpdate)) return true
        return false
    }

    const disableInfoPageSetting = () => {
        if (cluster && !room && !permissions.functionAction.find(value => (value.function === 'Cluster info page settings' || value.function === 'Cluster settings') && value.isUpdate)) return true
        if (cluster && room && !permissions.functionAction.find(value => value.function === 'Room settings' && value.isUpdate)) return true
        return false
    }

    const disableSave = () => {
        if (cluster && !room && !permissions.functionAction.find(value => value.function === 'Cluster settings' && value.isUpdate)) {
            if (!permissions.functionAction.find(value => value.function === 'Cluster info page settings' && value.isUpdate))
                return true
        }
        if (cluster && room && !permissions.functionAction.find(value => value.function === 'Room settings' && value.isUpdate)) return true
        return false
    }

    useEffect(() => {
        if (showSnackbarSave === true) {
            setTimeout(() => {
                setShowSnackbarSave(false);
            }, 6000);
        }
    }, [showSnackbarSave]);

    useEffect(() => {
        if (messageError !== '') {
            setTimeout(() => {
                setMessageError('');
            }, 6000);
        }
    }, [messageError]);

    useEffect(() => {
        var request = []
        setLoading(true)
        var infoPages
        var channelGroup
        var listLanguage
        request.push(
            dataProvider('GET_LIST', 'info-page-list', {
                sort: { field: 'name', order: 'ASC' },
                pagination: { page: 1, perPage: 100 },
                filter: {}
            }).then(({ data }) => {
                let temp = []
                temp.push({
                    createdAt: 1603093930191,
                    id: 'None',
                    name: "None",
                    template: { createdAt: 1601363433534, updatedAt: 1601363433534, id: 2, name: "staff" },
                    updatedAt: 1611650835649,
                    version: 0,
                })
                data.map(item => {
                    temp.push(item)
                })
                setInfoPageList(temp)
                infoPages = data
            }
            ).catch(error => {
                setLoading(false)
            }),
            dataProvider('GET_LIST', "channels/findgroup", {
                filter: {
                },
                pagination: {},
                sort: { field: 'name', order: 'ASC' },

            }).then(({ data }) => {
                setData(data);
                channelGroup = data
            }).catch(error => {
                setLoading(false);
            }),
            dataProvider('GET_LIST', 'language', {
                sort: { field: 'createdAt', order: 'DESC' },
                pagination: { page: 1, perPage: 100 },
                filter: {}
            }).then(({ data }) => {
                setLanguages(data);
                listLanguage = data
            }).catch((error) => {
                setLoading(false)
            })
        )
        Promise.all(request)
            .then(() => {
                getSettings(infoPages, channelGroup, listLanguage)
            })
            .catch(() => {
                console.log('Error')
                setLoading(false)
            })
        if (!cluster && !room) {
            setDataCategoryFilter(dataCategory)
        }
        if ((cluster && !room) || (cluster && room)) {
            let temp = cloneDeep(dataCategory)
            for (let i = temp.length - 1; i > 0; i--) {
                if (temp[i].id === 3 || temp[i].id === 5)
                    temp.splice(i, 1)
            }
            setDataCategoryFilter(temp)
        }
    }, []);

    useEffect(() => {
        if (isSave === true) {
            onEdit()
        }
    }, [isSave])

    useEffect(() => {
        if (isSaveInRoom === true) {
            onEdit()
        }
    }, [isSaveInRoom])

    if (!loaded) return null
    if (loading) return <Loading />
    return (
        <Box width='80%' m='auto'>
            <Prompt
                when={is_blocking_settings}
                message={location => {
                    if (is_blocking_settings) {
                        dispatch(pathNameSettings(location.pathname))
                        setOpenDialogAlert(true);
                        return false;
                    } else {
                        return true;
                    }
                }}
            />
            <Dialog open={openDialogAlert} onClose={handleCloseDialogAlert} aria-labelledby="form-dialog-title" classes={{
                paper: classes.paper
            }} >
                <Box className={classes.container}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} pt={1}>
                        <Typography className={classes.textClose}>{translate(`pos.common.close`)}</Typography>
                        <IconButton className={classes.borderClose} onClick={handleCloseDialogAlert} >
                            <Close color='primary' />
                        </IconButton>
                    </Box>
                    <img alt='image-save' src={imageInfo} className={classes.image} />
                    <Typography className={classes.titleUnSave}>{translate('resources.role.titleUnsave')}</Typography>
                    <Typography className={classes.contentUnSave}>{translate('resources.role.contentUnsave')}</Typography>

                    <Box mt={3}>
                        <Button
                            style={{ marginTop: 16, marginRight: 20 }}
                            onClick={handleCancelDialog}
                        >
                            <Typography className={classes.btnCancel}>{translate(`pos.dashboard.CANCEL`)}</Typography>
                        </Button>
                        <LoadingButton
                            label={translate(`resources.role.Save`)}
                            onClick={onSave}
                            loading={saving}
                        />
                    </Box>
                </Box>

            </Dialog>
            <LoadingSave show={saving} />
            {
                (!cluster) &&
                <Box>
                    <Box my={5} width={300}>
                    </Box>
                </Box>
            }
            <Box display='flex' justifyContent='center'>
                <Box width={500}>
                    <Snackbar
                        show={showSnackbarSave}
                        message={translate('pos.settings.saveSuccess')}
                        onClose={() => setShowSnackbarSave(false)}
                    />
                    <Box>
                        {
                            messageError != "" && (
                                <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                                    <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messageError}</Typography>
                                </Box>
                            )
                        }
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate('pos.settings.title')}</Typography>
                        <Box my={2}>
                            <SelectBoxFilter
                                // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                data={dataCategoryFilter}
                                label={translate('pos.settings.category')}
                                value={category ? category.name : 'All'}
                                onChange={(value) => onChangeCategory(value, 'category')}
                                // error={error.name.message !== '' && error.name.status}
                                // helperText={error.name.message}
                                keyName='name'
                                placeholder={translate('pos.settings.searchCategory')}
                            />
                        </Box>
                        <Box hidden={category && category.name !== 'Client' && category.name !== 'All'}>
                            <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.settings.categoryOption.clientChannel`)}</Typography>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <TextField
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    id='channelNumberInputTimeout'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.channelNumberInputTimeout')}
                                    // onBlur={() => { validate('channelNumberInput', textValue.channelNumberInputTimeoutLong) }}
                                    value={textValue.channelNumberInputTimeout}
                                    onChange={onChangTextValue('channelNumberInputTimeout')}
                                    type="number"
                                    // error={error.name.message !== '' && error.name.status}
                                    // helperText={error.name.message}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.channelNumberInputTimeout`)}
                                        content={translate(`pos.settings.contentNumberInputTimeout`)}
                                        icon={<b>?</b>}
                                    />} />
                            </Box>
                            {/* <Box my={2}>
                                <TextField
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    id='multicast'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.Multicast')}
                                    // onBlur={() => { validate('multicast', textValue.multicast) }}
                                    value={textValue.multicast}
                                    onChange={onChangTextValue('multicast')}
                                    // error={error.name.message !== '' && error.name.status}
                                    // helperText={error.name.message}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.Multicast`)}
                                        content={translate(`pos.settings.contentMulticast`)}
                                        icon={<b>?</b>}
                                    />} />
                            </Box> */}
                            {
                                !room &&
                                <Fragment>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '290px', height: '36px', backgroundColor: '#ffffff' }} >
                                        <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate('pos.settings.retryOnChannelPlaybackError')}</Typography>
                                        <FormControlLabel
                                            control={<CustomSwitch size="small" checked={playbackError} onChange={e => handleChangeSwitch(e, 'playbackError')} />}
                                            labelPlacement="start"
                                            variant="caption"
                                            style={{ margin: 0 }}
                                        />
                                    </Box>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '290px', height: '36px', backgroundColor: '#ffffff' }} >
                                        <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate('pos.settings.useChannelCategories')}</Typography>
                                        <FormControlLabel
                                            control={<CustomSwitch size="small" checked={categoryChannel} onChange={e => handleChangeSwitch(e, 'categoryChannel')} />}
                                            labelPlacement="start"
                                            variant="caption"
                                            style={{ margin: 0 }}
                                        />
                                    </Box>
                                </Fragment>
                            }
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <SelectBoxFilter
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    data={dataDLX}
                                    label={translate('pos.settings.DLXStartupMode')}
                                    value={DLXStartupMode ? DLXStartupMode.name : ''}
                                    onChange={(value) => onChangeCategory(value, 'DLXStartupMode')}
                                    // error={error.name.message !== '' && error.name.status}
                                    // helperText={error.name.message}
                                    keyName='name'
                                    placeholder={translate('pos.settings.searchDLXStartupMode')}
                                />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '290px', height: '36px', backgroundColor: '#ffffff' }} >
                                <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate('pos.settings.DLXEseStartupModeOnResume')}</Typography>
                                <FormControlLabel
                                    control={<CustomSwitch size="small" checked={DLXUseStartupMode} onChange={e => handleChangeSwitch(e, 'DLXUseStartupMode')} />}
                                    labelPlacement="start"
                                    variant="caption"
                                    style={{ margin: 0 }}
                                />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <TextField
                                    id='inactivityTimeout'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.inactivityTimeout')}
                                    value={textValue.inactivityTimeout}
                                    onChange={onChangTextValue('inactivityTimeout')}
                                    type="number"
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.inactivityTimeout`)}
                                        content={translate(`pos.settings.contentInactivityTimeout`)}
                                        icon={<b>?</b>}
                                    />} />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <SelectBoxFilter
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    data={dataInactiviTyTimeoutAction}
                                    label={translate('pos.settings.inactivityTimeoutAction')}
                                    value={inactivityTimeoutAction ? inactivityTimeoutAction.name : ''}
                                    onChange={(value) => onChangeCategory(value, 'inactivityTimeoutAction')}
                                    keyName='name'
                                    placeholder={translate('pos.settings.searchInactivityTimeoutAction')}
                                />
                            </Box>
                            <Box className={disableInfoPageSetting() ? classes.disabled : classes.enabled} my={2}>
                                <SelectBoxFilter
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    data={infoPageList}
                                    label={translate('pos.settings.infoPage')}
                                    value={infoPage ? infoPage.name : ''}
                                    onChange={(value) => onChangeCategory(value, 'infoPage')}
                                    keyName='name'
                                    placeholder={translate('pos.settings.searchInfoPage')}
                                />
                            </Box>

                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <SelectBoxFilter
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    data={dataInitialVolume}
                                    label={translate('pos.settings.initialVolume')}
                                    value={initialVolume ? initialVolume.name : ''}
                                    onChange={(value) => onChangeCategory(value, 'initialVolume')}
                                    keyName='name'
                                    placeholder={translate('pos.settings.searchInitialVolume')}
                                />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '290px', height: '36px', backgroundColor: '#ffffff' }} >
                                <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate('pos.settings.menuButtonAlwaysGoesToMainMenu')}</Typography>
                                <FormControlLabel
                                    control={<CustomSwitch size="small" checked={buttonMainMenu} onChange={e => handleChangeSwitch(e, 'buttonMainMenu')} />}
                                    labelPlacement="start"
                                    variant="caption"
                                    style={{ margin: 0 }}
                                />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <SelectBoxFilter
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    data={data}
                                    label={translate('pos.settings.defaultChannelGroup')}
                                    value={defaultChannelGroup ? defaultChannelGroup.name : ''}
                                    onChange={(value) => onChangeCategory(value, 'defaultChannelGroup')}
                                    keyName='name'
                                    placeholder={translate('pos.settings.searchDefaultChannelList')}
                                />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '290px', height: '36px', backgroundColor: '#ffffff' }} >
                                <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate('pos.settings.subtitlesEnabled')}</Typography>
                                <FormControlLabel
                                    control={<CustomSwitch size="small" checked={subtitlesEnabled} onChange={e => handleChangeSwitch(e, 'subtitlesEnabled')} />}
                                    labelPlacement="start"
                                    variant="caption"
                                    style={{ margin: 0 }}
                                />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '290px', height: '36px', backgroundColor: '#ffffff' }} >
                                <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate('pos.settings.useSessionBookmarks')}</Typography>
                                <FormControlLabel
                                    control={<CustomSwitch size="small" checked={useSession} onChange={e => handleChangeSwitch(e, 'useSession')} />}
                                    labelPlacement="start"
                                    variant="caption"
                                    style={{ margin: 0 }}
                                />
                            </Box>
                            {!cluster && !room &&
                                <Fragment>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                        <TextField
                                            id='defaultLockCode'
                                            style={{ width: 500 }}
                                            label={translate('pos.settings.defaultLockCode')}
                                            // onBlur={() => { validate('defaultLockCode', textValue.defaultLockCode) }}
                                            value={textValue.defaultLockCode}
                                            onChange={onChangTextValue('defaultLockCode')}
                                            // error={error.macAddress.message !== '' && error.macAddress.status}
                                            // helperText={error.macAddress.message}
                                            type='number'
                                            endDom={<CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.settings.defaultLockCode`)}
                                                content='Content Default Lock Code'
                                                icon={<b>?</b>}
                                            />} />
                                    </Box>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                        <TextField
                                            id='defaultPinCode'
                                            style={{ width: 500 }}
                                            label={translate('pos.settings.defaultPinCode')}
                                            // onBlur={() => { validate('macAddress', textValue.defaultPinCode) }}
                                            value={textValue.defaultPinCode}
                                            onChange={onChangTextValue('defaultPinCode')}
                                            // error={error.macAddress.message !== '' && error.macAddress.status}
                                            // helperText={error.macAddress.message}
                                            type='number'
                                            endDom={<CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.settings.defaultPinCode`)}
                                                content='Content Default Pin Code'
                                                icon={<b>?</b>}
                                            />} />
                                    </Box>
                                </Fragment>

                            }
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <TextField
                                    id='clientOperationMaxDelayOnUpgrade'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.maxDelayOnUpgrade')}
                                    // onBlur={() => { validate('macAddress', textValue.defaultPinCode) }}
                                    value={textValue.maxDelayOnUpgrade}
                                    onChange={onChangTextValue('maxDelayOnUpgrade')}
                                    // error={error.macAddress.message !== '' && error.macAddress.status}
                                    // helperText={error.macAddress.message}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.maxDelayOnUpgrade`)}
                                        content='Content Max Delay On Upgrade'
                                        icon={<b>?</b>}
                                    />} />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <TextField
                                    id='clientOperationMinDelayOnUpgrade'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.minDelayOnUpgrade')}
                                    // onBlur={() => { validate('macAddress', textValue.defaultPinCode) }}
                                    value={textValue.minDelayOnUpgrade}
                                    onChange={onChangTextValue('minDelayOnUpgrade')}
                                    // error={error.macAddress.message !== '' && error.macAddress.status}
                                    // helperText={error.macAddress.message}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.minDelayOnUpgrade`)}
                                        content='Content Min Delay On Upgrade'
                                        icon={<b>?</b>}
                                    />} />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <TextField
                                    id='ClientOperationOnUpgrade'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.onUpgrade')}
                                    // onBlur={() => { validate('macAddress', textValue.defaultPinCode) }}
                                    value={textValue.onUpgrade}
                                    onChange={onChangTextValue('onUpgrade')}
                                    // error={error.macAddress.message !== '' && error.macAddress.status}
                                    // helperText={error.macAddress.message}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.onUpgrade`)}
                                        content='Content On Upgrade'
                                        icon={<b>?</b>}
                                    />} />
                            </Box>
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <TextField
                                    id='maxTriggeredRequestsPerSecond'
                                    style={{ width: 500 }}
                                    label={translate('pos.settings.maxTriggeredRequests')}
                                    // onBlur={() => { validate('macAddress', textValue.defaultPinCode) }}
                                    value={textValue.maxTriggeredRequests}
                                    onChange={onChangTextValue('maxTriggeredRequests')}
                                    // error={error.macAddress.message !== '' && error.macAddress.status}
                                    // helperText={error.macAddress.message}
                                    type="number"
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.settings.maxTriggeredRequests`)}
                                        content='Content Max Triggered Requests'
                                        icon={<b>?</b>}
                                    />} />
                            </Box>
                        </Box>
                        {!cluster && !room &&
                            <Fragment>
                                <Box hidden={category && category.name !== 'General' && category.name !== 'All'}>
                                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.settings.categoryOption.generalInfoChannels`)}</Typography>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                        <TextField
                                            id='infoChannelMaxUploadSize'
                                            style={{ width: 500 }}
                                            label={translate('pos.settings.infoChannelMaxUploadSize')}
                                            // onBlur={() => { validate('infoChannelMaxUploadSize', textValue.infoChannelMaxUploadSize) }}
                                            value={textValue.infoChannelMaxUploadSize}
                                            onChange={onChangTextValue('infoChannelMaxUploadSize')}
                                            // error={error.macAddressSecondary.message !== '' && error.macAddressSecondary.status}
                                            // helperText={error.macAddressSecondary.message}
                                            type="number"
                                            endDom={<CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.settings.infoChannelMaxUploadSize`)}
                                                content='Content Max Upload Size (GB)'
                                                icon={<b>?</b>}
                                            />} />
                                    </Box>
                                </Box>
                                <Box hidden={category && category.name !== 'General' && category.name !== 'All'}>
                                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.settings.categoryOption.generalLanguagesAndLocales`)}</Typography>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                        <SelectBoxFilter
                                            // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                            data={languages}
                                            label={translate('pos.settings.defaultSystemLanguage')}
                                            value={defaultSystemLanguage ? defaultSystemLanguage.name : ''}
                                            onChange={(value) => onChangeCategory(value, 'defaultSystemLanguage')}
                                            keyName='name'
                                            placeholder={translate('pos.settings.searchDefaultSystemLanguage')}
                                        />
                                    </Box>
                                </Box>
                            </Fragment>
                        }
                        <Box hidden={category && category.name !== 'Services' && category.name !== 'All'}>
                            <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.settings.categoryOption.services`)}</Typography>
                            {!room &&
                                <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                    <TextField
                                        id='browserHomepage'
                                        style={{ width: 500 }}
                                        label={translate('pos.settings.browserHomepage')}
                                        value={textValue.browserHomepage}
                                        onChange={onChangTextValue('browserHomepage')}
                                        endDom={<CustomPoper
                                            open={openPoper}
                                            anchorEl={anchorEl}
                                            handleClick={handleClickOpenPoper}
                                            handleClose={handleClosePoper}
                                            title={translate('pos.settings.browserHomepage')}
                                            content={'Content Browser Homepage'}
                                            icon={<b>?</b>}
                                        />} />
                                </Box>}
                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                <SelectBoxFilter
                                    // disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                    data={timeZoneData}
                                    label={translate('pos.settings.timeZone')}
                                    value={timeZone ? timeZone.name : ''}
                                    onChange={(value) => onChangeCategory(value, 'timeZone')}
                                    keyName='name'
                                    placeholder={translate('pos.settings.searchTimeZone')}
                                />
                            </Box>
                        </Box>
                        {!cluster &&
                            <Fragment>
                                <Box hidden={category && category.name !== 'Support' && category.name !== 'All'}>
                                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.settings.categoryOption.supportEmail`)}</Typography>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                        <ChipInput
                                            value={emailSupports}
                                            onAdd={(chip) => handleAddChip(chip)}
                                            onDelete={(chip, index) => handleDeleteChip(chip, index)}
                                            dataSource={emailSupports}
                                            fullWidth
                                            fullWidthInput
                                            label={translate('pos.settings.supportMessage')}
                                            FormHelperTextProps={{
                                                className: classes.textError,
                                            }}
                                            InputLabelProps={{
                                                classes: {
                                                    root: classes.textLabel,
                                                    error: classes.textLabelError
                                                }
                                            }}
                                            InputProps={{
                                                className: classes.input,
                                                classes: {
                                                    underline: emailSupports !== '' ? classes.underline : classes.underlineNotValue,
                                                    focused: classes.focuses
                                                }
                                            }}
                                            classes={{
                                                chip: classes.chipInput,
                                                helperText: classes.textErrorChipInput
                                            }}
                                            style={{ backgroundColor: 'white' }}
                                        />
                                    </Box>{!room &&
                                        <Fragment>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} mt={3} mb={2}>
                                                <TextField
                                                    id='emailEncoding'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailEncoding')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailEncoding}
                                                    onChange={onChangTextValue('emailEncoding')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailEncoding')}
                                                        content='Content Email'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailPassword'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailPassword')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailPassword}
                                                    onChange={onChangTextValue('emailPassword')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailPassword')}
                                                        content='Content Email Password'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailPort'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailPort')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailPort}
                                                    onChange={onChangTextValue('emailPort')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailPort')}
                                                        content='Content Email Port'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailReply'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailReply')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailReply}
                                                    onChange={onChangTextValue('emailReply')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailReply')}
                                                        content='Content Email Reply'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailServer'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailServer')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailServer}
                                                    onChange={onChangTextValue('emailServer')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailServer')}
                                                        content='Content Email Server'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailSmtpTimeout'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailSmtpTimeout')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailSmtpTimeout}
                                                    onChange={onChangTextValue('emailSmtpTimeout')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailSmtpTimeout')}
                                                        content='Content Email Smtp Timeout'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailUsername'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailUsername')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailUsername}
                                                    onChange={onChangTextValue('emailUsername')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailUsername')}
                                                        content='Content Email Username'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                            <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                                <TextField
                                                    id='emailUsetls'
                                                    style={{ width: 500 }}
                                                    label={translate('pos.settings.emailUsetls')}
                                                    // onBlur={() => { validate('serialNumber', textValue.supportMessage) }}
                                                    value={textValue.emailUsetls}
                                                    onChange={onChangTextValue('emailUsetls')}
                                                    // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                                    // helperText={error.serialNumber.message}
                                                    endDom={<CustomPoper
                                                        open={openPoper}
                                                        anchorEl={anchorEl}
                                                        handleClick={handleClickOpenPoper}
                                                        handleClose={handleClosePoper}
                                                        title={translate('pos.settings.emailUsetls')}
                                                        content='Content Email Usetls'
                                                        icon={<b>?</b>}
                                                    />} />
                                            </Box>
                                        </Fragment>}
                                </Box>

                                <Box hidden={category && category.name !== 'Support' && category.name !== 'All'}>
                                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.settings.categoryOption.support`)}</Typography>
                                    <Box className={disableChange() ? classes.disabled : classes.enabled} my={2}>
                                        <TextField
                                            id='errorAlertLimit'
                                            style={{ width: 500 }}
                                            label={translate('pos.settings.errorAlertLimit')}
                                            // onBlur={() => { validate('errorAlertLimit', textValue.errorAlertLimit) }}
                                            value={textValue.errorAlertLimit}
                                            onChange={onChangTextValue('errorAlertLimit')}
                                            // error={error.serialNumber.message !== '' && error.serialNumber.status}
                                            // helperText={error.serialNumber.message}
                                            endDom={<CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate('pos.settings.errorAlertLimit')}
                                                content='Content Error Alert Limit'
                                                icon={<b>?</b>}
                                            />} />
                                    </Box>
                                </Box>
                            </Fragment>
                        }
                        <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                            {/* <Box className={!permissions.functionAction.find(value => value.function === 'Client devices' && (value.isUpdate || value.isRead)) ? classes.disabled : classes.enabled}>
                                <Button style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/ClientDevice" }} >
                                    <Typography className={classes.btnCancel}
                                    >
                                        {translate(`pos.dashboard.CANCEL`)}</Typography>
                                </Button>
                            </Box> */}
                            <Button className={disableSave() ? classes.disabled : classes.enabled} style={{ padding: 8 }} variant='contained' color='primary' onClick={onEdit}>
                                {translate(`pos.common.save`)}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

Settings.propTypes = {
    isEdit: PropTypes.bool
};

export default Settings